<section class="container">
    <header>
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl cursor-pointer" style="float: right;"
            (click)="ref.close()"></i>
        <div class="title-component text-center">{{title}}</div>
        <p>{{subtitle}}</p>
    </header>
    <main>
        <div class="container movements-container px-0">
            <div class="d-flex justify-content-center align-items-center py-5" *ngIf="isLoadingRealtimePayments">
                <div class="spinner-border text-primary" role="status" aria-label="Cargando historial de pagos">
                    <span class="sr-only">Cargando...</span>
                </div>
            </div>

            <ng-container *ngIf="!isLoadingRealtimePayments">
                <ng-container *ngIf="showExtraSections; else legacyList">
                    <mat-tab-group class="payments-tabs" animationDuration="150ms">
                        <!-- Confirmados (incluye pagos legacy) -->
                        <mat-tab *ngIf="shippingCostToDisplay.length"
                            [label]="'Confirmados (' + shippingCostToDisplay.length + ')'">
                            <ng-container *ngFor="let shippingCost of shippingCostToDisplay; let i = index">
                                <ng-container *ngTemplateOutlet="paymentRow; context: {$implicit: shippingCost, index: i, readOnly: false}"></ng-container>
                            </ng-container>
                        </mat-tab>

                        <!-- En procesamiento -->
                        <mat-tab *ngIf="extraPaymentsByStatus.processing.length"
                            [label]="'En procesamiento (' + extraPaymentsByStatus.processing.length + ')'">
                            <ng-container *ngFor="let shippingCost of extraPaymentsByStatus.processing; let i = index">
                                <ng-container *ngTemplateOutlet="paymentRow; context: {$implicit: shippingCost, index: i, readOnly: true}"></ng-container>
                            </ng-container>
                        </mat-tab>

                        <!-- Fallidos -->
                        <mat-tab *ngIf="extraPaymentsByStatus.failed.length"
                            [label]="'Fallidos (' + extraPaymentsByStatus.failed.length + ')'">
                            <ng-container *ngFor="let shippingCost of extraPaymentsByStatus.failed; let i = index">
                                <ng-container *ngTemplateOutlet="paymentRow; context: {$implicit: shippingCost, index: i, readOnly: true}"></ng-container>
                            </ng-container>
                        </mat-tab>

                        <!-- Eliminados -->
                        <mat-tab *ngIf="extraPaymentsByStatus.deleted.length"
                            [label]="'Eliminados (' + extraPaymentsByStatus.deleted.length + ')'">
                            <ng-container *ngFor="let shippingCost of extraPaymentsByStatus.deleted; let i = index">
                                <ng-container *ngTemplateOutlet="paymentRow; context: {$implicit: shippingCost, index: i, readOnly: true}"></ng-container>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </ng-container>

                <!-- Modo no-payments: DiscountsAndBonuses, PaymentsDeleted, etc. -->
                <ng-template #legacyList>
                    <ng-container *ngFor="let shippingCost of shippingCostToDisplay; let i = index">
                        <ng-container *ngTemplateOutlet="paymentRow; context: {$implicit: shippingCost, index: i, readOnly: false}"></ng-container>
                    </ng-container>
                </ng-template>
            </ng-container>
        </div>
    </main>
    <br>
    <footer>
        <div class="text-center">
            <button mat-raised-button color="accent" class="m-auto" (click)="ref.close()">Aceptar</button>
        </div>
    </footer>
</section>

<!-- Template reusable de una fila de pago / descuento / bonificación -->
<ng-template #paymentRow let-shippingCost let-i="index" let-readOnly="readOnly">
    <div class="row movement-item" [ngClass]="{'background-gray': i%2===0}">
        <div class="col-md-6 d-flex flex-column">
            <b class="bold text-nowrap mb-1">
                {{shippingCost?.date?.includes('/') ? shippingCost?.date
                : (shippingCost?.date | date:'yyyy/MM/dd hh:mm a')}}
            </b>

            <small *ngIf="shippingCost?.type && ['Payments', 'PaymentsDeleted'].includes(typePayment)">
                <i>{{cargoItemService.getTypePaid(shippingCost?.type)}}</i>
                <br>
                <i *ngIf="shippingCost?.conceptType">Concepto: {{shippingCost?.conceptType}}</i>
            </small>
            <small>
                {{shippingCost?.typeModification?.name ? shippingCost?.typeModification?.name :
                typePayment=='PaymentsDeleted' ? '(Pago eliminado)' : ''}}
            </small>
            <br>
            <small class="text-nowrap d-flex flex-wrap" *ngIf="shippingCost?.userId || shippingCost?.userName">
                <span class="text-bold mr-2">
                    {{users[shippingCost?.userId]?.information?.name
                    ? users[shippingCost?.userId]?.information?.name
                    : shippingCost?.userName? shippingCost?.userName : '-'}}
                </span>
                <span class="mr-2"> ({{shippingCost?.userId}})</span>
                <span *ngIf="users[shippingCost?.userId]?.email">
                    {{users[shippingCost?.userId]?.email}}
                </span>
            </small>
            <small *ngIf="shippingCost?.receiptId">
                <span class="text-bold mr-2">ID del recibo:</span>
                <span class="mr-2">{{shippingCost?.receiptId}}</span>
            </small>
        </div>
        <div class="col-md-6 m-auto d-flex flex-column justify-content-center align-items-md-center">
            <div *ngIf="shippingCost.amountRate > 0" class="mt-1">
                <b class="bold">Tarifa:</b>
                <b class="text-nowrap bold" [ngClass]="
                    {
                        'text-danger': shippingCost.type==1,
                        'text-success' : shippingCost.type==0,
                        'text-info': shippingCost.type != 0 && shippingCost.type != 1
                    }">
                    {{shippingCost.type == 0 ? '+' : shippingCost.type == 1 ? '-' : ''}}
                    {{shippingCost.amountRate | currency:'COP'}}
                </b>
            </div>
            <div *ngIf="shippingCost.amount > 0" class="mt-1">
                <b class="bold">{{shippingCost.type != 0 && shippingCost.type != 1 ? 'Pago': 'Flete'}}:</b>
                <b class="text-nowrap bold" [ngClass]="
                    {
                        'text-danger': shippingCost.type==1,
                        'text-success' : shippingCost.type==0,
                        'text-info': shippingCost.type != 0 && shippingCost.type != 1
                    }">
                    {{shippingCost.type == 0 ? '+' : shippingCost.type == 1 ? '-' : ''}}
                    {{shippingCost.amount | currency:'COP'}}
                </b>
            </div>
        </div>
        <small class="col-12 d-flex flex-wrap alert alert-info justify-content-center mt-3 mb-0" role="alert"
            *ngIf="shippingCost?.fingerPrintObservation">
            <span class="text-bold col-12 text-center">
                Observación
                {{shippingCost?.fingerPrintObservation?.fingerPrint?.userName
                ? ' - ' + shippingCost?.fingerPrintObservation?.fingerPrint?.userName: '-'}}
                ({{shippingCost?.fingerPrintObservation?.fingerPrint?.userId}})
            </span>
            <span class="col-12 text-center">
                {{shippingCost?.fingerPrintObservation?.observation}}
            </span>
        </small>
        <div class="col-12"
            *ngIf="shippingCost?.observation && shippingCost?.observation != shippingCost?.typeModification?.name">
            <small>
                Observación: <br><i>{{shippingCost?.observation}}</i>
            </small>
        </div>
        <small class="col-12 d-flex flex-wrap alert alert-danger justify-content-center mt-3 mb-0" role="alert"
            *ngIf="getDeletedFingerprint(shippingCost)">
            <span class="text-bold col-12 text-center mb-2">
                Responsable de la eliminación
            </span>
            <span class="text-bold mr-2">
                {{getDeletedFingerprint(shippingCost)?.userName
                ? getDeletedFingerprint(shippingCost)?.userName: '-'}}
            </span>
            <span class="mr-2" *ngIf="getDeletedFingerprint(shippingCost)?.userId">
                ({{getDeletedFingerprint(shippingCost)?.userId}})
            </span>
            <span *ngIf="getDeletedFingerprint(shippingCost)?.date">
                {{getDeletedFingerprint(shippingCost)?.date |dateFormat}}
            </span>
        </small>
        <i class="fas fa-trash trash-icon" *ngIf="!readOnly && showDeleteButton()"
            [ngClass]="{'disabled-option':!canDeleteElement(shippingCost).canDelete}"
            [matTooltip]="canDeleteElement(shippingCost).error" matTooltipClass="tooltip__error"
            (click)="openDialogDelete(shippingCost)"></i>
    </div>
</ng-template>
